import { ranges } from "../../../utilities/dateRangeToShortString.ts";

import { MeasureDateRange } from "../../../../../../../api/types/fieldConfigurationTypes.ts";

const measureRanges = ranges.filter((r) => r.value !== MeasureDateRange.Ltm);
const metricRanges = ranges.filter(
  (r) => r.value !== MeasureDateRange.BeginningBalance && r.value !== MeasureDateRange.Mtd
);

export type Ranges = typeof ranges;

export function getMeasureRanges() {
  return measureRanges;
}

export function getMetricRanges() {
  return metricRanges;
}
